module.exports = __webpack_public_path__ + "img/Rogue-human-f-70.28e73a00.gif";